'use client';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html>
      <body className="bg-gray-900">
        <div className="min-h-screen flex items-center justify-center p-4">
          <div className="bg-gray-800 border border-red-700 rounded-lg p-8 max-w-md w-full">
            <h2 className="text-2xl font-bold text-red-500 mb-4">Global Error</h2>
            <p className="text-gray-300 mb-6">
              Something went wrong at the application level.
            </p>
            <p className="text-sm text-gray-400 mb-6">
              {error.message}
            </p>
            <button
              onClick={reset}
              className="w-full bg-red-600 hover:bg-red-700 text-white font-medium py-2 px-4 rounded transition-colors"
            >
              Reset application
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}